<template>
  <div class="error-page">
    <div class="error-page-img">
      <img class="img" src="../assets/images/500.png" />
    </div>
    <div class="error-page-desc">哎呀，服务器开小差啦</div>
    <div class="error-page-btn">
      <el-button style="width:180px" @click="goBack">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error500',
  mounted() {
    // this.$router.back()
    window.addEventListener('unload', () => {
      this.$router.back()
    })
  },
  methods: {
    goBack() {
      this.$router.back()
    }
  }
}
</script>
